"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeField = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_aria_components_1 = require("react-aria-components");
var theme_1 = require("../../theme");
/**
 * A time field allows users to enter and edit time values using a keyboard.
 * It provides a structured way to input hours, minutes, and seconds with proper validation.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/TimeField.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-timefield--default}
 *
 * @example
 * ```tsx
 * <TimeField>
 *   <Label>Event time</Label>
 *   <DateInput>
 *     {segment => <DateSegment segment={segment} />}
 *   </DateInput>
 * </TimeField>
 * ```
 *
 * @param value - The current time value
 * @param defaultValue - The default time value
 * @param isDisabled - Whether the time field is disabled
 * @param isReadOnly - Whether the time field is read only
 * @param isRequired - Whether the time field is required
 * @param minValue - The minimum allowed time value
 * @param maxValue - The maximum allowed time value
 * @param children - The time input components to display
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.TimeField = (0, styled_1.default)(react_aria_components_1.TimeField)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), theme_1.theme.space.space8);
var templateObject_1;
//# sourceMappingURL=TimeField.js.map